import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import * as listActions from '../lookbooksList/actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';
import store from '../../../store';

function* deleteLookbook({ payload: { id, onSuccess } }) {
  const { getState, dispatch } = store;

  try {
    const { data } = yield call(fetch, { api: api.lookbooks.delete, id });

    dispatch(listActions.getLookbooksRequest({ curr_page: getState().getLookbooks.curr_page }));

    onSuccess && onSuccess();
    yield put(actions.deleteLookbookDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.deleteLookbookFailed,
      endpoint: api.lookbooks.delete.url
    });
  }
}

export const deleteLookbookSaga = takeEvery(types.DELETE_LOOKBOOK_REQUEST, deleteLookbook);